import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetJobNotFoundLink() {
  const countryCode = useSiteCountryCode();

  return `/${countryCode}/jobs/job-not-found`;
}
